import { Sel, STagNew } from '#~/stag/tag.js';
import { DialogClose } from '@radix-ui/react-dialog';
import { Button } from '@studio/design-system/button';
import { useCallback, type ReactElement } from 'react';

interface DestinationFooterProps {
  hasChanges: boolean;
  isEditMode: boolean;
  isAdditionMode?: boolean;
  // generic save function
  onSave?: () => void;
  // generic close function
  onClose?: (open: boolean) => void;
  // Specific to destination logic
  onDestinationDelete?: () => void;
  onDestinationAdd?: () => void;
  onDestinationEdit?: () => void;
}

export const DestinationFooter = ({
  hasChanges,
  isAdditionMode = false,
  isEditMode = false,
  onSave,
  onClose,
  onDestinationDelete,
  onDestinationAdd,
  onDestinationEdit
}: DestinationFooterProps): ReactElement => {
  // Generic close function
  const handleClose = useCallback(() => {
    onClose && onClose(false);
  }, [onClose]);

  return (
    <div className='absolute bottom-0 left-0 right-0'>
      <div className='flex justify-between bg-base-100 px-40 py-24'>
        {isEditMode && onDestinationDelete && (
          <Button variant='danger' onClick={onDestinationDelete}>
            Delete Destination
          </Button>
        )}
        {isAdditionMode && onDestinationAdd && (
          <div className='flex w-full justify-between gap-16'>
            <div>
              <DialogClose onClick={handleClose}>
                <Button variant='secondary' className={isEditMode ? 'ml-20' : ''}>
                  Cancel
                </Button>
              </DialogClose>
            </div>
            <div>
              <Button
                variant='primary'
                disabled={!hasChanges}
                onClick={onDestinationAdd}
                {...STagNew(Sel.ProductionOutput, 'rtmp-destination-save')}
              >
                Save Changes
              </Button>
            </div>
          </div>
        )}
        {isEditMode && onDestinationEdit && (
          <div className='flex w-full justify-end gap-16'>
            <div>
              <DialogClose onClick={handleClose}>
                <Button variant='secondary' className={isEditMode ? 'ml-20' : ''}>
                  Cancel
                </Button>
              </DialogClose>
            </div>
            <div>
              <Button
                variant='primary'
                disabled={!hasChanges}
                onClick={onDestinationEdit}
                {...STagNew(Sel.ProductionOutput, 'rtmp-destination-save')}
              >
                Save Changes
              </Button>
            </div>
          </div>
        )}

        {!isEditMode && !isAdditionMode && (
          <>
            <DialogClose onClick={handleClose}>
              <Button variant='secondary'>Cancel</Button>
            </DialogClose>
            <Button
              variant='primary'
              disabled={!hasChanges}
              onClick={onSave}
              {...STagNew(Sel.ProductionOutput, 'rtmp-destination-save')}
            >
              Save Changes
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
